<div class="calendar">
  <div class="timeline fixed-left">
    <div></div>
    <div class="time-marker">09:00</div>
    <div></div>
    <div class="time-marker">10:00</div>
    <div></div>
    <div class="time-marker">11:00</div>
    <div></div>
    <div class="time-marker">12:00</div>
    <div></div>
    <div class="time-marker">13:00</div>
    <div></div>
    <div class="time-marker">16:00</div>
    <div class="time-marker-half">16:30</div>
    <div class="time-marker">17:00</div>
    <div class="time-marker-half">17:30</div>
    <div class="time-marker">18:00</div>
    <div class="time-marker-half">18:30</div>
    <div class="time-marker">19:00</div>
    <div class="time-marker-half">19:30</div>
    <div class="time-marker">20:00</div>
    <div class="time-marker-half">20:30</div>
  </div>
  <div class="days text-xs">
    <div class="day mon">
      <div class="day-header">Montag</div>
      <div class="events">
        <div class="event start-1200 end-1300 bjj-gi">
          <p class="title">BJJ GI</p>
        </div>
        <div class="event start-1630 end-1730 bjj-kids">
          <span class="title">BJJ KIDS I. GI (3-6J)</span>
        </div>
        <div class="event start-1730 end-1830 bjj-kids">
          <span class="title">BJJ KIDS II. NO-GI (7-12J)</span>
        </div>
        <div class="double-event start-1830 end-1930">
          <div class="sub-event bjj-no-gi">
            <p class="title">NO-GI</p>
          </div>
          <div class="sub-event bjj-women flex-1">
            <p class="title">BJJ Women GI</p>
          </div>
        </div>
        <div class="event start-1930 end-2100 muay-thai">
          <p class="title">Kru Muay Thai Fightclub</p>
          <p>Alle Stufen</p>
        </div>
      </div>
    </div>
    <div class="day tue">
      <div class="day-header">Dienstag</div>
      <div class="events">
        <div class="event start-1200 end-1300 openmat-intern">
          <p class="title">OPEN MAT</p>
          <p>intern</p>
        </div>
        <div class="event start-1800 end-1930 bjj-gi">
          <p class="title">BJJ GI</p>
        </div>
        <div class="event start-1930 end-2100 muay-thai">
          <p class="title">Kru Muay Thai Fightclub</p>
          <p>Alle Stufen</p>
        </div>
      </div>
    </div>
    <div class="day wed">
      <div class="day-header">Mittwoch</div>
      <div class="events">
        <div class="event start-1200 end-1300 bjj-gi">
          <p class="title">BJJ GI</p>
        </div>
        <div class="event start-1700 end-1800 bjj-kids">
          <p class="title">BJJ KIDS I. GI (3-6J)</p>
        </div>
        <div class="event start-1800 end-1900 bjj-kids">
          <p class="title">BJJ KIDS II. GI (7-12J)</p>
        </div>
        <div class="double-event start-1900 end-2000">
          <div class="sub-event bjj-no-gi">
            <p class="title">NO-GI</p>
          </div>
          <div class="sub-event bjj-women flex-1">
            <p class="title">BJJ Women GI</p>
          </div>
        </div>
        <div class="event start-2000 end-2100 muay-thai">
          <p class="title">Kru Muay Thai</p>
          <p>Sparring</p>
        </div>
      </div>
    </div>
    <div class="day thu">
      <div class="day-header">Donnerstag</div>
      <div class="events">
        <div class="event start-1200 end-1300 openmat-intern">
          <p class="title">OPEN MAT</p>
          <p>intern</p>
        </div>
        <div class="event start-1730 end-1830 bjj-kids">
          <p class="title">BJJ KIDS II. GI (7-12J)</p>
        </div>
        <div class="event start-1830 end-1930 bjj-gi">
          <p class="title">BJJ GI</p>
        </div>
        <div class="event start-1930 end-2100 muay-thai">
          <p class="title">Kru Muay Thai Fightclub</p>
          <p>Alle Stufen</p>
        </div>
      </div>
    </div>
    <div class="day fri">
      <div class="day-header">Freitag</div>
      <div class="events">
        <div class="event start-1200 end-1300 openmat-intern">
          <p class="title">OPEN MAT</p>
          <p>intern</p>
        </div>
        <div class="event start-1800 end-1930 bjj-gi">
          <p class="title">BJJ GI</p>
        </div>
        <div class="event start-1930 end-2100 muay-thai">
          <p class="title">Kru Muay Thai Fightclub</p>
          <p>Alle Stufen</p>
        </div>
      </div>
    </div>
    <div class="day sat">
      <div class="day-header">Samstag</div>
      <div class="events">

        <div class="event start-0900 end-1000 bjj-kids">
          <p class="title">BJJ KIDS I. GI (3-6J)</p>
        </div>
        <div class="event start-1000 end-1100 bjj-kids">
          <p class="title">BJJ KIDS II. GI (7-12J)</p>
        </div>
        <div class="event start-1100 end-1200 openmat-extern">
          <p class="title">OPEN MAT</p>
          <p>for all teams</p>
        </div>
      </div>
    </div>
  </div>
</div>
